
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 46 46","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22.5","cy":"22.5","r":"22.5","fill":"#4fa2b7"}}),_c('path',{attrs:{"id":"Fill-1","d":"M10.6 13.6c0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4S14.3 16 13 16c-1.3 0-2.4-1-2.4-2.4m3.2 23.9v-20c.4-.1.9-.3 1.2-.5 1.3-.8 2.1-2.3 1.9-3.9-.2-1.8-1.7-3.2-3.5-3.4-2.3-.3-4.4 1.6-4.4 3.9 0 1.5.8 2.7 1.9 3.4.4.2.8.4 1.2.5v19.9","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}}),_c('path',{staticClass:"st2",attrs:{"fill":"#fff","d":"M33.5 19.8v9.5h1.1V17.4c-.1.8-1.1 2-1.1 2.1v.3zM34.1 14.9c-.2 0-.4 0-.6-.1v1.3c0 1.5-1.9 2.9-3.4 3.2l-15.7 1.8v1.6l16-2.1c1.2-.3 2.3-.9 3.1-1.8.6-.7 1-1.4 1.1-2.3V14.7c-.2.1-.3.2-.5.2z"}}),_c('g',[_c('path',{staticClass:"st2",attrs:{"fill":"#fff","d":"M34 9.5c1.1 0 1.9.9 1.9 1.9s-.9 1.9-1.9 1.9-1.9-.9-1.9-1.9.9-1.9 1.9-1.9m0-1c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9-1.2-2.9-2.9-2.9z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/fieldCableFill.svg